import React from 'react';
import PropTypes from 'prop-types';
export class ExecuteButton extends React.Component {
    constructor(props) {
        super(props);
        this._onClick = () => {
            if (this.props.isRunning) {
                this.props.onStop();
            }
            else {
                this.props.onRun();
            }
        };
        this._onOptionSelected = operation => {
            this.setState({ optionsOpen: false });
            this.props.onRun(operation.name && operation.name.value);
        };
        this._onOptionsOpen = downEvent => {
            let initialPress = true;
            const downTarget = downEvent.target;
            this.setState({ highlight: null, optionsOpen: true });
            let onMouseUp = upEvent => {
                if (initialPress && upEvent.target === downTarget) {
                    initialPress = false;
                }
                else {
                    document.removeEventListener('mouseup', onMouseUp);
                    onMouseUp = null;
                    const isOptionsMenuClicked = downTarget.parentNode.compareDocumentPosition(upEvent.target) &
                        Node.DOCUMENT_POSITION_CONTAINED_BY;
                    if (!isOptionsMenuClicked) {
                        this.setState({ optionsOpen: false });
                    }
                }
            };
            document.addEventListener('mouseup', onMouseUp);
        };
        this.state = {
            optionsOpen: false,
            highlight: null,
        };
    }
    render() {
        const operations = this.props.operations;
        const optionsOpen = this.state.optionsOpen;
        const hasOptions = operations && operations.length > 1;
        let options = null;
        if (hasOptions && optionsOpen) {
            const highlight = this.state.highlight;
            options = (React.createElement("ul", { className: "execute-options" }, operations.map(operation => (React.createElement("li", { key: operation.name ? operation.name.value : '*', className: operation === highlight ? 'selected' : undefined, onMouseOver: () => this.setState({ highlight: operation }), onMouseOut: () => this.setState({ highlight: null }), onMouseUp: () => this._onOptionSelected(operation) }, operation.name ? operation.name.value : '<Unnamed>')))));
        }
        let onClick;
        if (this.props.isRunning || !hasOptions) {
            onClick = this._onClick;
        }
        let onMouseDown;
        if (!this.props.isRunning && hasOptions && !optionsOpen) {
            onMouseDown = this._onOptionsOpen;
        }
        const pathJSX = this.props.isRunning ? (React.createElement("path", { d: "M 10 10 L 23 10 L 23 23 L 10 23 z" })) : (React.createElement("path", { d: "M 11 9 L 24 16 L 11 23 z" }));
        return (React.createElement("div", { className: "execute-button-wrap" },
            React.createElement("button", { type: "button", className: "execute-button", onMouseDown: onMouseDown, onClick: onClick, title: "Execute Query (Ctrl-Enter)" },
                React.createElement("svg", { width: "34", height: "34" }, pathJSX)),
            options));
    }
}
ExecuteButton.propTypes = {
    onRun: PropTypes.func,
    onStop: PropTypes.func,
    isRunning: PropTypes.bool,
    operations: PropTypes.array,
};
//# sourceMappingURL=ExecuteButton.js.map